import React, { useState, useEffect } from "react";
import { Field } from "react-final-form";
import Cookies from "js-cookie";

import { CONTINENTS } from "../../../constants";
import { EXPECTED_COOKIES, GET_USER_LEVEL, GET_TOKEN } from "../../../helpers";
// import { OBJECT_EMPTY } from "../../../helpers";

import "./CompanyInformation.css";

export const CompanyInformation = (props) => {
  const [showCountryOfDispatch, setShowCountryOfDispatch] = useState(false);
  const [requiredFields, setRequiredFields] = useState([]);
  const fields = props.SecondStepformContent;

  // Adding items to hook for validation
  useEffect(() => {
    let newObject = [];

    if (!requiredFields.length) {
      // eslint-disable-next-line
      Object.entries(fields).map(([fieldItem, fieldItemValue]) => {
        if (
          fieldItem === "email" ||
          fieldItem === "password" ||
          fieldItem === "passwordrepeat" ||
          !fields[fieldItem]["required"]
        ) {
          // eslint-disable-next-line
          return;
        } else {
          newObject = [...newObject, fieldItemValue.name];
        }
      });
    }

    setRequiredFields(newObject);
    // eslint-disable-next-line
  }, []);

  // check if ShowCountryOfDispatch
  useEffect(() => {
    if ( props.defaultProduct === 2001 || props.defaultProduct === 2002) { 
      setShowCountryOfDispatch(true) 
    }
  }, [])

  const SpecificValueSelected = (e) => {
    if (
      e.target.name === "countryOfDispatch" ||
      (e.target.name === "digitalGoods" &&
        (e.target.value === "2001" || e.target.value === "2002"))
    ) {
      setShowCountryOfDispatch(true);
    } else if (
      e.target.name === "digitalGoods" &&
      !(e.target.value === "2001" || e.target.value === "2002")
    ) {
      setShowCountryOfDispatch(false);
    } else {
      return;
    }
  };

  const checkIfRequiredFullfiled = (counterForNotFilled) => {
    let counted = 0;

    console.log(requiredFields)


    requiredFields.map((item) => {
      const input = document.querySelector("." + item + " input");
      const select = document.querySelector("." + item + " select");

      if (props.values[item] === '' || props.values[item] === null || props.values[item] === undefined) {
        input && input.classList.add("field-error");
        select && select.classList.add("field-error");

        return counted++;
      } else {
        input && input.classList.remove("field-error");
        select && select.classList.remove("field-error");

        return counted;
      }
    });

    return counted;
  };

  // const checkIfMoss = () => {
  //   // check if any values selected that makes moss active
  //   if (
  //     props.values["digitalGoods"] === "1001" ||
  //     props.values["digitalGoods"] === "1002"
  //   ) {
  //     props.setMoss(true);
  //   }
  // };

  const continueToCountry = () => {
    // check if all required values are filled.
    console.log(`checkIfRequiredFullfiled`, checkIfRequiredFullfiled())
    if (checkIfRequiredFullfiled() === 0) {
      // check if any values selected that makes moss active
      // checkIfMoss();

      // proceed further


      if (GET_TOKEN()) {
        // props.setCurrentStep(3)
      } else {
        props.stepChange();
      }
    }
  };

  return (
    <div className="CompanyInformation registration-page-step">
      <h3 className="registration-page-step__title">Company information</h3>

      {/* Listing all the fields */}
      <div className="registration-page-step__fields-wrapper">
        <div className="CompanyInformation__fields-wrapper full-width">
          <div className="company-info full-width">
            <div className="one-three-block">
              <div className={"field-item " + fields.companyname.name}>
                <p className="title">{fields.companyname.title}</p>
                <Field
                  className={"registration-input register-input"}
                  name={fields.companyname.name}
                  type="text"
                  key={fields.companyname.name}
                  component="input"
                  autoComplete="off"
                  defaultValue={props.companyname && props.companyname}
                  disabled={GET_USER_LEVEL() < 4 && props.companyname !== null}
                />
              </div>

              <div className={"field-item " + fields.countryincorporation.name}>
                <p className="title">{fields.countryincorporation.title}</p>
                <Field
                  name={fields.countryincorporation.name}
                  defaultValue={props.countryincorporation && props.countryincorporation}
                >
                  {({ input }) => {
                    const { onChange } = input;
                    const mergedOnChange = (e) => onChange(e);
                    const newInput = { ...input, onChange: mergedOnChange };

                    return (
                      <select {...newInput} className="registration-input" disabled={GET_USER_LEVEL() < 4 && props.countryincorporation !== null}>

                        {/* Placeholder */}
                        <option disabled value="" key={1}>
                          {fields.countryincorporation.placeholder}
                        </option>

                        {/* Values */}
                        {Object.entries(props.countries).map(
                          ([item, continentValue]) => {
                            return (
                              <optgroup label={CONTINENTS[item]} key={item}>
                                {continentValue.map((country) => (
                                  <option value={country.id} key={country.id}>
                                    {country.name}
                                  </option>
                                ))}
                              </optgroup>
                            );
                          }
                        )}
                      </select>
                    );
                  }}
                </Field>
              </div>
            </div>

            <div className="one-three-block">
              <div className={"field-item " + fields.companycode.name}>
                <p className="title">{fields.companycode.title}</p>
                <Field
                  className={"registration-input register-input"}
                  name={fields.companycode.name}
                  type="text"
                  key={fields.companycode.name}
                  component="input"
                  autoComplete="off"
                  defaultValue={props.companycode && props.companycode}
                />
              </div>

              <div className={"field-item " + fields.accountingcurrency.name}>
                <p className="title">{fields.accountingcurrency.title}</p>
                <Field name={fields.accountingcurrency.name} defaultValue={props.accountingcurrency && props.accountingcurrency}>
                  {({ input }) => {
                    const { onChange } = input;
                    const mergedOnChange = (e) => onChange(e);
                    const newInput = { ...input, onChange: mergedOnChange };

                    return (
                      <select {...newInput} className="registration-input">
                        {/* Placeholder */}
                        <option disabled value="" key={1}>
                          {fields.accountingcurrency.placeholder}
                        </option>

                        {/* Values */}
                        {fields.accountingcurrency["content"].map((item) => {
                          return (
                            <option value={item.value} key={item.value}>
                              {item.name}
                            </option>
                          );
                        })}
                      </select>
                    );
                  }}
                </Field>
              </div>
            </div>

            <div className="one-three-block">
              <div className={"field-item " + fields.pricingType.name}>
                <p className="title">{fields.pricingType.title}</p>
                <Field name={fields.pricingType.name} defaultValue={props.pricingType && props.pricingType}>
                  {({ input }) => {
                    const { onChange } = input;
                    const mergedOnChange = (e) => onChange(e);
                    const newInput = { ...input, onChange: mergedOnChange };

                    return (
                      <select {...newInput} className="registration-input" disabled={GET_USER_LEVEL() < 4 && props.pricingType !== null}>
                        {/* Placeholder */}
                        <option disabled value="" key={1}>
                          {fields.pricingType.placeholder}
                        </option>

                        {/* Values */}
                        {fields.pricingType["content"].map((item) => {
                          return (
                            <option value={item.value} key={item.value}>
                              {item.name}
                            </option>
                          );
                        })}
                      </select>
                    );
                  }}
                </Field>
              </div>

              <div
                className={
                  "field-item half-width last-item " +
                  fields.defaultProduct.name
                }
              >
                <p className="title">{fields.defaultProduct.title}</p>
                <Field name={fields.defaultProduct.name} defaultValue={props.defaultProduct && props.defaultProduct}>
                  {({ input }) => {
                    const { onChange } = input;
                    const mergedOnChange = (e) => {
                      SpecificValueSelected(e);
                      onChange(e);
                    };
                    const newInput = { ...input, onChange: mergedOnChange };

                    return (
                      <select {...newInput} className="registration-input " disabled={GET_USER_LEVEL() < 4 && props.defaultProduct !== null}>
                        {/* Placeholder */}
                        <option disabled value="" key={1}>
                          {fields.defaultProduct.placeholder}
                        </option>

                        {/* Values */}
                        {fields.defaultProduct["content"].map((item) => {
                          return (
                            <option value={item.value} key={item.value}>
                              {item.name}
                            </option>
                          );
                        })}
                      </select>
                    );
                  }}
                </Field>
              </div>

              {showCountryOfDispatch ? (
                <div
                  className={
                    "field-item last-item " + fields.countryOfDispatch.name
                  }
                >
                  <p className="title">{fields.countryOfDispatch.title}</p>
                  <Field name={fields.countryOfDispatch.name} defaultValue={props.countryOfDispatch && props.countryOfDispatch}>
                    {({ input }) => {
                      const { onChange } = input;
                      const mergedOnChange = (e) => {
                        SpecificValueSelected(e);
                        onChange(e);
                      };
                      const newInput = { ...input, onChange: mergedOnChange };

                      return (
                        <select {...newInput} className="registration-input" disabled={GET_USER_LEVEL() < 4 && props.countryOfDispatch !== null}>

                        {/* Placeholder */}
                        <option disabled value="" key={1}>
                          {fields.countryOfDispatch.placeholder}
                        </option>

                        {/* Values */}
                        {Object.entries(props.countries).map(
                            ([item, continentValue]) => {
                              return (
                                <optgroup label={CONTINENTS[item]} key={item}>
                                  {continentValue.map((country) => (
                                    <option value={country.id} key={country.id}>
                                      {country.name}
                                    </option>
                                  ))}
                                </optgroup>
                              );
                            }
                          )}
                        </select>
                      );
                    }}
                  </Field>
                </div>
              ) : null}
            </div>
          </div>

          <div className="business-info half-width">
            <h4 className="full-width">Business address</h4>

            <div
              className={"field-item half-width-register " + fields.city.name}
            >
              <p className="title">{fields.city.title}</p>

              <Field
                className={"registration-input register-input"}
                name={fields.city.name}
                type="text"
                key={fields.city.name}
                component="input"
                autoComplete="off"
                defaultValue={props.city && props.city}
              />
            </div>

            <div
              className={"field-item half-width-register " + fields.zip.name}
            >
              <p className="title">{fields.zip.title}</p>

              <Field
                className={"registration-input register-input"}
                name={fields.zip.name}
                type="text"
                key={fields.zip.name}
                component="input"
                autoComplete="off"
                defaultValue={props.zip && props.zip}
              />
            </div>

            <div className={"field-item full-width " + fields.address.name}>
              <p className="title">{fields.address.title}</p>

              <Field
                className={"registration-input register-input"}
                name={fields.address.name}
                type="text"
                key={fields.address.name}
                component="input"
                autoComplete="off"
                defaultValue={props.address && props.address}
              />
            </div>
          </div>

          <div className="person-info half-width">
            <h4 className="full-width">Responsible person contact details</h4>

            <div className="half-width">
              <div className={"field-item " + fields.contactname.name}>
                <p className="title">{fields.contactname.title}</p>
                <Field
                  className={"registration-input register-input"}
                  name={fields.contactname.name}
                  type="text"
                  key={fields.contactname.name}
                  component="input"
                  autoComplete="off"
                  defaultValue={props.contactname && props.contactname}
                />
              </div>

              <div className={"field-item " + fields.emailprimary.name}>
                <p className="title">{fields.emailprimary.title}</p>

                <Field
                  className={"registration-input register-input"}
                  name={fields.emailprimary.name}
                  type="text"
                  key={fields.emailprimary.name}
                  component="input"
                  autoComplete="off"
                  defaultValue={props.userInfoValues?.company?.primary_email_address && props.userInfoValues.company.primary_email_address}
                />
              </div>
            </div>

            <div className="half-width">
              <div className={"field-item " + fields.phone.name}>
                <p className="title">
                  {fields.phone.title}
                  <span className="subtitle">{fields.phone.subtitle}</span>
                </p>

                <Field
                  className={"registration-input register-input"}
                  name={fields.phone.name}
                  type="text"
                  key={fields.phone.name}
                  component="input"
                  autoComplete="off"
                  defaultValue={props.phone && props.phone}
                />
              </div>

              <div className={"field-item " + fields.emailsecondary.name}>
                <p className="title">{fields.emailsecondary.title}</p>
                <Field
                  className={"registration-input register-input"}
                  name={fields.emailsecondary.name}
                  type="text"
                  key={fields.emailsecondary.name}
                  component="input"
                  autoComplete="off"
                  defaultValue={props.emailsecondary && props.emailsecondary}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Proceed button */}
      <div className="registration-page-step__button-wrapper">
        <button
          type={ GET_TOKEN() ? "submit" : "button"}
          // type="submit"
          className="registration-input registration-input__button"
          onClick={(e) => {
            if (checkIfRequiredFullfiled() === 0) {
              if (!GET_TOKEN()) {
                props.stepChange();
              }
            } else {
              e.preventDefault()
            }
          }}
        >
          {
            Cookies.get(EXPECTED_COOKIES.userJwt.name)
             ? 'Save'
             : 'proceed'
          }
        </button>
      </div>
    </div>
  );
};
